<template>
  <panel-block id="pn-required" panel-group>
    <panel-item>
      <label :for="model.idForProp('aggregate_type')">Choose an Aggregate Function</label>
      <a-select
        :id="model.idForProp('aggregate_type')"
        :options="aggregateOptions"
        compress
        v-model="model.aggregate_type"
        @input="$emit('input')"
      ></a-select>
    </panel-item>
  </panel-block>
</template>

<script lang="ts">
  import Vue from "vue";
  import {IAggregatable} from "~/interfaces/propertyInterfaces";
  import {IDefaultVOption} from "~/interfaces/vSelectInterfaces";
  import {aggregateOptions} from "~/enums/aggregateType";

  export default Vue.extend({
    name: 'aggregatable-config',
    props: {
      model: {
        type: Object as () => IAggregatable,
        required: true,
      },
    },
    data: function () {
      return {};
    },
    computed: {
      aggregateOptions(): IDefaultVOption[] {
        return aggregateOptions()
      }
    }
  });
</script>
